<template>
  <div
  >
    <div>
      <div class="drawer lg:drawer-open">
        <input
            id="my-drawer-2"
            type="checkbox"
            class="drawer-toggle"
        >
        <div class="drawer-content flex flex-col">
          <!-- Page content here -->
          <label
              for="my-drawer-2"
              class="btn btn-primary drawer-button absolute lg:hidden"
          >

          </label>
          <div class="flex flex-col justify-center bg-base-100">
            <section class="px-8 py-6 m-4 rounded-lg shadow-xl">
              <!-- Page content -->
              <slot />
            </section>
          </div>
        </div>

        <nav class="drawer-side">
          <label
              for="my-drawer-2"
              class="drawer-overlay"
          />
          <div class="w-80 bg-base-100 text-base-content h-full">
            <h1 class="font-bold p-4">Karten-Designer</h1>
            <ul class="menu bg-base-200 w-full px-4">
              <li class="menu-title">
                <span>Bereiche</span>
              </li>
              <li>
                <NuxtLink to="/design/"
                          activeClass="active">
                    <font-awesome-icon :icon="faImages" />
                    Entwerfen
                </NuxtLink>
              </li>
              <li>
                <NuxtLink to="/write/"
                          activeClass="active">
                            <font-awesome-icon :icon="faKeyboard" />
                  Schreiben
                </NuxtLink>
              </li>
              <li>
                <NuxtLink to="/print/"
                          activeClass="active">
                            <font-awesome-icon :icon="faPrint" />
                  Drucken
                </NuxtLink>
              </li>
            </ul>
            <ul class="menu">
              <slot name="menu" />
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { faBrush, faImages, faKeyboard, faPrint, faSignature } from "@fortawesome/free-solid-svg-icons";
import { useNuxtApp } from "nuxt/app";
const { $surreal } = useNuxtApp();

// const { data, error, pending } = await query('SELECT username FROM $auth')
$surreal()
  .then(async surreal => {
    await surreal.info();
  })
  .catch (err => {
    console.warn('not able to fetch user info:', err);
    navigateTo('/login');
  })

const name = computed(() => {
  if (!data.value?.username) {
    return ''
  } else {
    return data.value?.username
  }
})

</script>
